import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ProductCategory } from '../../entities/@products/ProductCategory/ProductCategory';
import { Link } from '../../entities/Link/Link';
import { Space } from '../../entities/Space/Space';
import { AsyncReduxState, initialAsyncReduxState } from '../defaults';

export type SpaceState = AsyncReduxState<{
    spaces: Space[];
    space?: Space;
    categories: ProductCategory[];
    breadcrumbs: Link[];
}>;

const initialState: SpaceState = {
    ...initialAsyncReduxState,
    spaces: [],
    categories: [],
    breadcrumbs: [],
};

const spaceSlice = createSlice({
    name: 'spaceSlice',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): SpaceState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setHasFetched(state, action: PayloadAction<boolean>): SpaceState {
            return {
                ...state,
                hasFetched: action.payload,
            };
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): SpaceState {
            return {
                ...state,
                isSuccessful: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): SpaceState {
            return {
                ...state,
                error: action.payload,
            };
        },
        setSpaces(state, action: PayloadAction<Space[]>): SpaceState {
            return {
                ...state,
                spaces: action.payload,
            };
        },
        setSpace(state, action: PayloadAction<Space | undefined>): SpaceState {
            return {
                ...state,
                space: action.payload,
            };
        },
        setCategories(state, action: PayloadAction<ProductCategory[]>): SpaceState {
            return {
                ...state,
                categories: action.payload,
            };
        },
        setBreadcrumbs(state, action: PayloadAction<Link[]>): SpaceState {
            return {
                ...state,
                breadcrumbs: action.payload,
            };
        },
    },
});

export const {
    setIsLoading,
    setHasFetched,
    setIsSuccessful,
    setError,
    setSpaces,
    setSpace,
    setCategories,
    setBreadcrumbs,
} = spaceSlice.actions;

export default spaceSlice;
